<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import vueTouch from "../static/touch.js";
export default {
  name: 'App'
}
</script>

<style>
	body, h1, h2, h3, h4, h5, h6, p, ul, ol, dl, dd, td, input, select, option, textarea, img {
	  margin: 0;
	  padding: 0; }
	html,body{
	  height: 100%;
	}
	body {
	  font-family: "微软雅黑";
	  display: flex;
	  flex-direction: column;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
		}
  body::-webkit-scrollbar { width: 0 !important }
	a {
	  text-decoration: none; }
	ul {
	  list-style: none; }
	img {
	  display: block; }
</style>



// WEBPACK FOOTER //
// src/App.vue